(function () {
  /**
   * The "hand" tool for BatchGeo's Drawing Manager. The hand tool is really just
   * the default Google Map's behavior (for now) so enable and disable doesn't do
   * anything. We still need a button though so it's a component.
   */
  var BatchGeoDrawingManagerHand = {
    button: {
      class: "drawing-manager-button drawing-manager-button-hand has-children",
      title: "Move tool",
      order: 3,
      icon: "hand",
      mode: "hand",
    },
    enable: function () {},
    disable: function () {},
  };
  window.BatchGeoDrawingManagerHand = BatchGeoDrawingManagerHand;
})(window);
